/**
 * Reformat Judge.me pagination to: ‹ 1 2 3 … N › (Blog-style)
 */
(function () {
  var ENHANCED = 'data-jdgm-pag-enhanced';
  var BUSY = 'data-jdgm-pag-busy';

  function isNav(el) {
    return (
      el.classList.contains('jdgm-paginate__prev-page') ||
      el.classList.contains('jdgm-paginate__next-page') ||
      el.classList.contains('jdgm-paginate__first-page') ||
      el.classList.contains('jdgm-paginate__last-page')
    );
  }

  function parseState(root) {
    var links = Array.prototype.slice.call(root.querySelectorAll('a.jdgm-paginate__page'));
    var current = 1;
    var last = 1;
    var pages = [];

    links.forEach(function (link) {
      var page = Number(link.getAttribute('data-page'));
      if (!page || Number.isNaN(page)) return;

      if (link.classList.contains('jdgm-curt')) current = page;

      if (isNav(link)) {
        if (link.classList.contains('jdgm-paginate__last-page')) last = Math.max(last, page);
        return;
      }

      pages.push(page);
      last = Math.max(last, page);
    });

    last = Math.max(last, current);
    if (!pages.length) pages = [current];

    return { current: current, last: last, pages: pages };
  }

  /** Build visible page list with null = ellipsis — front shows 1 2 3 … N */
  function buildVisible(current, last) {
    if (last <= 4) {
      var all = [];
      for (var i = 1; i <= last; i++) all.push(i);
      return all;
    }

    var set = {};
    set[1] = true;
    set[last] = true;

    if (current <= 2) {
      // Three pages before ellipsis: 1 2 3 … last
      set[1] = true;
      set[2] = true;
      set[3] = true;
    } else if (current >= last - 1) {
      set[last - 2] = true;
      set[last - 1] = true;
      set[last] = true;
    } else {
      set[current - 1] = true;
      set[current] = true;
      set[current + 1] = true;
    }

    var nums = Object.keys(set)
      .map(Number)
      .sort(function (a, b) {
        return a - b;
      });

    var out = [];
    for (var j = 0; j < nums.length; j++) {
      if (j > 0 && nums[j] - nums[j - 1] > 1) out.push(null);
      out.push(nums[j]);
    }
    return out;
  }

  function makePage(page, current) {
    var a = document.createElement('a');
    a.className = 'jdgm-paginate__page' + (page === current ? ' jdgm-curt' : '');
    a.setAttribute('data-page', String(page));
    a.setAttribute('aria-label', 'Page ' + page);
    a.setAttribute('tabindex', '0');
    a.setAttribute('role', 'button');
    a.textContent = String(page);
    return a;
  }

  function makeArrow(type, page, disabled) {
    var a = document.createElement('a');
    a.className =
      'jdgm-paginate__page jdgm-paginate__' +
      type +
      '-page' +
      (disabled ? ' jdgm-disabled' : '');
    a.setAttribute('data-page', String(page));
    a.setAttribute('aria-label', type === 'prev' ? 'Previous page' : 'Next page');
    a.setAttribute('tabindex', disabled ? '-1' : '0');
    a.setAttribute('role', 'button');
    if (disabled) a.setAttribute('aria-disabled', 'true');
    if (type === 'next' && !disabled) a.setAttribute('rel', 'next');
    if (type === 'prev' && !disabled) a.setAttribute('rel', 'prev');
    // SVG chevrons (same as Blog) — avoid Judge.me icon font tofu boxes on Mac
    a.innerHTML =
      type === 'prev'
        ? '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14" aria-hidden="true" focusable="false"><path d="M8.5 1.5 2.5 7l6 5.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14" aria-hidden="true" focusable="false"><path d="M1.5 1.5 7.5 7l-6 5.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return a;
  }

  function makeGap() {
    var span = document.createElement('span');
    span.className = 'jdgm-paginate__gap';
    span.setAttribute('aria-hidden', 'true');
    span.textContent = '…';
    return span;
  }

  function enhance(root) {
    if (!root || root.getAttribute(BUSY) === '1') return;

    var state = parseState(root);
    if (state.last < 1) return;

    var signature =
      state.current +
      ':' +
      state.last +
      ':' +
      buildVisible(state.current, state.last).join(',');
    if (root.getAttribute(ENHANCED) === signature) return;

    root.setAttribute(BUSY, '1');

    var frag = document.createDocumentFragment();
    frag.appendChild(makeArrow('prev', Math.max(1, state.current - 1), state.current <= 1));

    buildVisible(state.current, state.last).forEach(function (item) {
      if (item === null) frag.appendChild(makeGap());
      else frag.appendChild(makePage(item, state.current));
    });

    frag.appendChild(
      makeArrow('next', Math.min(state.last, state.current + 1), state.current >= state.last)
    );

    root.innerHTML = '';
    root.appendChild(frag);
    root.setAttribute(ENHANCED, signature);
    root.removeAttribute(BUSY);
  }

  function enhanceAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.jdgm-paginate'), enhance);
  }

  function init() {
    enhanceAll();

    var timer = null;
    var obs = new MutationObserver(function (mutations) {
      var needs = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var node = m.target;
        if (
          (node.classList && node.classList.contains('jdgm-paginate')) ||
          (node.querySelector && node.querySelector('.jdgm-paginate')) ||
          (m.addedNodes &&
            Array.prototype.some.call(m.addedNodes, function (n) {
              return (
                n.nodeType === 1 &&
                (n.classList.contains('jdgm-paginate') ||
                  (n.querySelector && n.querySelector('.jdgm-paginate')))
              );
            }))
        ) {
          // Skip while we are rewriting a paginate root
          if (node.closest && node.closest('.jdgm-paginate[' + BUSY + '="1"]')) continue;
          needs = true;
          break;
        }
      }
      if (!needs) return;
      clearTimeout(timer);
      timer = setTimeout(enhanceAll, 30);
    });

    obs.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
